import TourPackageHttp from "../../tourPackageHttp";

class PackageServices {

static async createPackages(data){
    return TourPackageHttp.post('/packages/create',data);
}

  static async getPackages() {
    return TourPackageHttp.post("/packages");
  }
  static async getPackageById(id) {
    return TourPackageHttp.get(`/packages/${id}`);
  }
  // static async getDriverTripcount(id){
  //     return Http.get(`/rider-trip-counts/${id}`);
  // }
  static async updatePackage(id, data) {
    console.log(
      "========================================data in the updatePlace",
      data
    );
    return TourPackageHttp.update(`/packages/${id}`, data);
  }
  static async addPackage(data) {
    return TourPackageHttp.post("/packages/create", data);
  }

  static async deletePackage(id) {
    return TourPackageHttp.delete(`/packages/${id}`);
  }

  static async getPackageDetailsById(id){
    return TourPackageHttp.get(`/packagesDetails/${id}`);
  }

  static async updatePackageDetailsById(id,data){
    console.log("data in the updatePackageDetailsById ",data)
    return TourPackageHttp.update(`/packagesDetails/${id}`,data)
  }
}
export default PackageServices;
